import Primary from './Primary';

export default Primary;
